import {
  usePaginatedResource,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import { useQuery } from "@tanstack/react-query"
import {
  getPettyCashPaymentFromList,
  createPettyCashPaymentFrom,
  updatePettyCashPaymentFrom,
  deletePettyCashPaymentFrom,
  getPettyCashPaymentModeList,
  createPettyCashPaymentMode,
  updatePettyCashPaymentMode,
  deletePettyCashPaymentMode,
  getPettyCashPaymentPurposeList,
  createPettyCashPaymentPurpose,
  updatePettyCashPaymentPurpose,
  deletePettyCashPaymentPurpose,
  getPettyCashBalance,
  getPettyCashSummary,
  getPettyCashDailySummary,
  getPettyCashMonthlySummary,
} from "api/pettyCashMasterApi"

// ---------- Payment From ----------
export const PETTY_CASH_PAYMENT_FROM_KEY = "petty-cash-payment-from"

export const usePettyCashPaymentFroms = (params = {}, enabled = true) =>
  usePaginatedResource(PETTY_CASH_PAYMENT_FROM_KEY, getPettyCashPaymentFromList, params, enabled)

export const useCreatePettyCashPaymentFrom = () =>
  useCreateResource(createPettyCashPaymentFrom, PETTY_CASH_PAYMENT_FROM_KEY)

export const useEditPettyCashPaymentFrom = () =>
  useEditResource(updatePettyCashPaymentFrom, PETTY_CASH_PAYMENT_FROM_KEY)

export const useDeletePettyCashPaymentFrom = () =>
  useDeleteResource(deletePettyCashPaymentFrom, PETTY_CASH_PAYMENT_FROM_KEY)

// ---------- Payment Mode ----------
export const PETTY_CASH_PAYMENT_MODE_KEY = "petty-cash-payment-mode"

export const usePettyCashPaymentModes = (params = {}, enabled = true) =>
  usePaginatedResource(PETTY_CASH_PAYMENT_MODE_KEY, getPettyCashPaymentModeList, params, enabled)

export const useCreatePettyCashPaymentMode = () =>
  useCreateResource(createPettyCashPaymentMode, PETTY_CASH_PAYMENT_MODE_KEY)

export const useEditPettyCashPaymentMode = () =>
  useEditResource(updatePettyCashPaymentMode, PETTY_CASH_PAYMENT_MODE_KEY)

export const useDeletePettyCashPaymentMode = () =>
  useDeleteResource(deletePettyCashPaymentMode, PETTY_CASH_PAYMENT_MODE_KEY)

// ---------- Payment Purpose ----------
export const PETTY_CASH_PAYMENT_PURPOSE_KEY = "petty-cash-payment-purpose"

export const usePettyCashPaymentPurposes = (params = {}, enabled = true) =>
  usePaginatedResource(PETTY_CASH_PAYMENT_PURPOSE_KEY, getPettyCashPaymentPurposeList, params, enabled)

export const useCreatePettyCashPaymentPurpose = () =>
  useCreateResource(createPettyCashPaymentPurpose, PETTY_CASH_PAYMENT_PURPOSE_KEY)

export const useEditPettyCashPaymentPurpose = () =>
  useEditResource(updatePettyCashPaymentPurpose, PETTY_CASH_PAYMENT_PURPOSE_KEY)

export const useDeletePettyCashPaymentPurpose = () =>
  useDeleteResource(deletePettyCashPaymentPurpose, PETTY_CASH_PAYMENT_PURPOSE_KEY)

// ---------- Reports ----------
export const usePettyCashBalance = (enabled = true) =>
  useQuery({
    queryKey: ["petty-cash-balance"],
    queryFn: getPettyCashBalance,
    enabled,
  })

export const usePettyCashSummary = (params = {}, enabled = true) =>
  useQuery({
    queryKey: ["petty-cash-summary", params],
    queryFn: () => getPettyCashSummary(params),
    enabled,
  })

export const usePettyCashDailySummary = (params = {}, enabled = true) =>
  useQuery({
    queryKey: ["petty-cash-daily-summary", params],
    queryFn: () => getPettyCashDailySummary(params),
    enabled,
  })

export const usePettyCashMonthlySummary = (params = {}, enabled = true) =>
  useQuery({
    queryKey: ["petty-cash-monthly-summary", params],
    queryFn: () => getPettyCashMonthlySummary(params),
    enabled,
  })
